class ASMProductPageGroups {
  constructor(root) {
    this.root = root;
    root.asmPageGroups = this;
    this.handle = root.dataset.productHandle;
    this.group = (window.ASM_PRODUCT_GROUPS || {})[this.handle];
    if (!this.group || this.group.length < 2) return;
    this.mount();
  }

  mount() {
    const media = this.root.querySelector('.product__media-wrapper');
    if (!media || media.querySelector('.asm-product-carousel')) return;
    this.mountCarousel(media, (window.Shopify?.routes?.root) || '/');
  }

  mountCarousel(media, rootPath) {
    const index = this.group.findIndex(item => item.handle === this.handle);
    if (index < 0) return null;
    const carousel = document.createElement('nav');
    carousel.className = 'asm-product-carousel';
    carousel.setAttribute('aria-label', 'Digər məhsul seçimləri');
    [-1, 1].forEach(direction => {
      const item = this.group[(index + direction + this.group.length) % this.group.length];
      const link = document.createElement('a');
      link.className = 'asm-product-carousel__arrow';
      link.dataset.asmCarouselDirection = String(direction);
      link.href = `${rootPath}products/${item.handle}`;
      link.setAttribute('aria-label', `${direction < 0 ? 'Əvvəlki' : 'Növbəti'} məhsul: ${item.label}`);
      link.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${direction < 0 ? 'm14 6-6 6 6 6' : 'm10 6 6 6-6 6'}"/></svg>`;
      carousel.appendChild(link);
    });
    const position = document.createElement('span');
    position.className = 'asm-product-carousel__position';
    position.textContent = `Məhsul ${index + 1} / ${this.group.length}`;
    position.setAttribute('aria-label', `${this.group.length} seçimdən ${index + 1}-ci məhsul`);
    carousel.appendChild(position);
    media.appendChild(carousel);
    return carousel;
  }

  destroy() {
    this.observer?.disconnect();
    this.touchLayout?.removeEventListener('change', this.positionChoice);
    if (this.documentClickHandler) document.removeEventListener('click', this.documentClickHandler);
    if (this.keyDownHandler) document.removeEventListener('keydown', this.keyDownHandler);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('product-info[data-product-handle]').forEach((root) => new ASMProductPageGroups(root));
});
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('product-info[data-product-handle]').forEach((root) => new ASMProductPageGroups(root));
});
